export function isResponseError(error: any): error is { response: Response } {
  if (typeof error !== 'object') {
    return false;
  }

  return error.response instanceof Response;
}
